<script setup lang="ts">
import { useState } from '#app'
import { computed } from 'vue'
import type { CmsVideo, CmsData } from '~/layers/cms/app/types/cmsTypes'
import { getByPath } from '../../utils/cmsDataHelper'

const cmsData = useState<CmsData>('cmsData')

if (!cmsData) {
  throw new Error('cmsData not provided')
}

const props = defineProps<{
  cmsDataPath: (string | number)[]
  global?: boolean
}>()

const video = computed(() => getByPath(cmsData.value, props.cmsDataPath)?.component_data as CmsVideo)
</script>

<template>
  <video
    v-cms-video-element:[video]="{ path: props.cmsDataPath, global: props.global }"
    v-bind="{
      ...(video?.video_path ? { src: video.video_path } : {}),
      autoplay: video?.autoplay ?? true,
      muted: video?.muted ?? true,
      loop: video?.loop ?? false,
      controls: video?.controls ?? true,
      ...(video?.poster ? { poster: video.poster } : {}),
      preload: video?.preload ?? 'auto',
      playsinline: video?.playsinline ?? true,
      ...(video?.width ? { width: video.width } : {}),
      ...(video?.height ? { height: video.height } : {})
    }"
  />
</template>
